import React from "react";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import ProductActions from "./ProductActions";
import { useGetProductsHandler } from "../dataHandlers/getProductsHandler";
import { currencyFormatter } from "../../../utils/currencyFormat";
import CustomPagination from "../../../components/customPagination";
import { getUOMOptions } from "../../../api/codelist/codeListsSlice";

const ProductsTable = ({ searchQuery = {}, handlePaginationChange }) => {
  const uomOptions = useSelector(getUOMOptions);
  const { products, totalDocuments, isLoading } = useGetProductsHandler({
    searchQuery,
  });

  const columns = [
    { field: "name", headerName: "Item Name", flex: 2 },
    {
      field: "unit_of_measure",
      headerName: "Unit of Measure",
      flex: 1,
      renderCell: (params) => {
        return (
          uomOptions.find((uom) => uom.code === params.value)?.name ||
          params.value
        );
      },
    },
    {
      field: "unit_price",
      headerName: "Unit Price",
      flex: 1,
      align: "right",
      renderCell: (params) => currencyFormatter().format(params.value),
    },
    {
      field: "item_type",
      headerName: "Item Type",
      flex: 0.8,
      renderCell: (params) =>
        params?.row?.item_specification_document_reference?.item_type || "",
    },
    {
      field: "classified_tax_category",
      headerName: "Tax Category",
      flex: 1,
      renderCell: (params) => params?.value?.id,
    },
    {
      field: "tax_category_rate",
      headerName: "Tax Rate",
      flex: 1,
      renderCell: (params) => {
        const tc = params?.row.classified_tax_category;
        return tc?.percent != null ? `${tc.percent}%` : "";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => <ProductActions product={params.row} />,
    },
  ];

  return (
    <Box>
      <DataGrid
        loading={isLoading}
        rows={products}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default ProductsTable;
